const FileUploadService = _ref => {
  let {
    uploadUrl,
    file,
    onProgress,
    onError,
    onDelete
  } = _ref;
  const key = 'docs_upload_example_us_preset';
  const xhr = new XMLHttpRequest();
  xhr.open('POST', uploadUrl);
  xhr.onabort = () => {
    if (typeof onError === 'function') {
      onError('server', file, 'file upload cancelled', 'aborted');
    }
  };
  xhr.onerror = () => {
    if (typeof onError === 'function') {
      onError('server', file, 'an error occurred', 'unknown-server-error');
      onDelete(file);
    }
  };
  xhr.upload.onprogress = event => {
    if (event.lengthComputable) {
      const percentage = event.loaded / event.total * 100;
      onProgress(Math.round(percentage));
    }
  };
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', key); // might be removed in the future
  xhr.send(formData);
  return xhr;
};
export default FileUploadService;